import { render, staticRenderFns } from "./SystemManager.vue?vue&type=template&id=ee129784&scoped=true&"
import script from "@/scripts/adminManager/systemManager.js?vue&type=script&lang=js&"
export * from "@/scripts/adminManager/systemManager.js?vue&type=script&lang=js&"
import style0 from "./SystemManager.vue?vue&type=style&index=0&id=ee129784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee129784",
  null
  
)

export default component.exports